"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAndSubmitInProgress = exports.validateAndSubmit = exports.updateFormField = exports.fetchLoanDocument = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("./constants");
var http = require('lc-http');
var validateAndSubmitInProgress = function validateAndSubmitInProgress() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT_INPROGRESS,
              payload: {
                navigationToNextPage: '',
                submissionInProgress: true
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.validateAndSubmitInProgress = validateAndSubmitInProgress;
var validateAndSubmit = function validateAndSubmit() {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState) {
      var _getState, siteInfo, document, tracking, basePath, isSourceAspen, loanId, postURL, isDocumentViewed, esignAgreementChecked, loanAgreementChecked, applicationTermsAgreementChecked, submissionInProgress, offerId, postEndPoint, eventPayLoad, postBody, _yield$http$post, signedStatusResponse, error, reloadPage, signedStatus, isError, _postBody, _yield$http$post2, _signedStatusResponse, _error, _signedStatus, _isError;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState = getState(), siteInfo = _getState.siteInfo, document = _getState.document;
            tracking = siteInfo.tracking, basePath = siteInfo.basePath, isSourceAspen = siteInfo.isSourceAspen;
            loanId = document.loanId, postURL = document.postURL, isDocumentViewed = document.isDocumentViewed, esignAgreementChecked = document.esignAgreementChecked, loanAgreementChecked = document.loanAgreementChecked, applicationTermsAgreementChecked = document.applicationTermsAgreementChecked, submissionInProgress = document.submissionInProgress, offerId = document.offerId;
            postEndPoint = "".concat(basePath).concat(postURL);
            _context2.prev = 4;
            eventPayLoad = {
              PF_PROVIDER_CLIENT_ID: loanId
            };
            if (!isSourceAspen) {
              _context2.next = 23;
              break;
            }
            if (!(loanAgreementChecked && applicationTermsAgreementChecked && isDocumentViewed && esignAgreementChecked)) {
              _context2.next = 22;
              break;
            }
            postBody = {
              applicationId: loanId,
              isSourceAspen: isSourceAspen,
              esignAgreementChecked: esignAgreementChecked,
              applicationTermsAgreementChecked: applicationTermsAgreementChecked,
              offerId: offerId
            };
            _context2.next = 11;
            return http.post(postEndPoint, postBody);
          case 11:
            _yield$http$post = _context2.sent;
            signedStatusResponse = _yield$http$post.data;
            error = signedStatusResponse.error, reloadPage = signedStatusResponse.reload, signedStatus = signedStatusResponse.data;
            isError = !!error;
            if (!reloadPage) {
              _context2.next = 17;
              break;
            }
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                reloadPage: reloadPage,
                navigationToNextPage: false,
                error: isError,
                submissionInProgress: !submissionInProgress
              }
            }));
          case 17:
            if (!((signedStatus === null || signedStatus === void 0 ? void 0 : signedStatus.submitStatus) === 'STALE')) {
              _context2.next = 21;
              break;
            }
            eventPayLoad[_constants.PF_DOC_SLATE_ERROR_EVENT] = true;
            (0, _constants.trackEventWithHeap)(siteInfo.tracking, _constants.PF_DOC_SLATE_ERROR_EVENT, eventPayLoad);
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                submissionInProgress: !submissionInProgress,
                error: _constants.REFRESH_PAGE_ERROR,
                reloadPage: false
              }
            }));
          case 21:
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: true,
                error: isError,
                submissionInProgress: true,
                reloadPage: false
              }
            }));
          case 22:
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                error: _constants.CHECK_BOX_ERROR,
                reloadPage: false
              }
            }));
          case 23:
            if (!(loanAgreementChecked && isDocumentViewed)) {
              _context2.next = 36;
              break;
            }
            _postBody = {
              applicationId: loanId
            };
            _context2.next = 27;
            return http.post(postEndPoint, _postBody);
          case 27:
            _yield$http$post2 = _context2.sent;
            _signedStatusResponse = _yield$http$post2.data;
            _error = _signedStatusResponse.error, _signedStatus = _signedStatusResponse.data;
            _isError = _error && isSourceAspen ? true : false;
            if (!((_signedStatus === null || _signedStatus === void 0 ? void 0 : _signedStatus.submitStatus) === 'STALE')) {
              _context2.next = 35;
              break;
            }
            eventPayLoad[_constants.PF_DOC_SLATE_ERROR_EVENT] = true;
            (0, _constants.trackEventWithHeap)(siteInfo.tracking, _constants.PF_DOC_SLATE_ERROR_EVENT, eventPayLoad);
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                submissionInProgress: !submissionInProgress,
                error: _constants.REFRESH_PAGE_ERROR,
                reloadPage: false
              }
            }));
          case 35:
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: true,
                error: _isError,
                submissionInProgress: isSourceAspen ? true : !submissionInProgress,
                reloadPage: false
              }
            }));
          case 36:
            eventPayLoad[_constants.PF_DOC_CHECKBOX_ERROR_EVENT] = true;
            (0, _constants.trackEventWithHeap)(tracking, _constants.PF_DOC_CHECKBOX_ERROR_EVENT, eventPayLoad);
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                error: _constants.CHECK_BOX_ERROR,
                reloadPage: false
              }
            }));
          case 41:
            _context2.prev = 41;
            _context2.t0 = _context2["catch"](4);
            return _context2.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                error: _constants.GENERIC_ERROR,
                submissionInProgress: isSourceAspen ? true : !submissionInProgress,
                reloadPage: false
              }
            }));
          case 44:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 41]]);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.validateAndSubmit = validateAndSubmit;
var updateFormField = function updateFormField(data) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch, getState) {
      var _getState2, document, siteInfo, error, esignCheck, applicationTermsCheck, loanCheck, docCheck, isError;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), document = _getState2.document, siteInfo = _getState2.siteInfo;
            error = document.error;
            esignCheck = data.esignAgreementChecked;
            applicationTermsCheck = data.applicationTermsAgreementChecked;
            loanCheck = data.loanAgreementChecked;
            docCheck = data.isDocumentViewed;
            isError = siteInfo.isSourceAspen ? !docCheck || !applicationTermsCheck || !loanCheck || !esignCheck : !docCheck || !esignCheck;
            return _context3.abrupt("return", dispatch({
              type: _constants.UPDATE_FORM_FIELD,
              payload: {
                esignAgreementChecked: esignCheck,
                applicationTermsAgreementChecked: applicationTermsCheck,
                loanAgreementChecked: loanCheck,
                isDocumentViewed: docCheck,
                error: isError && error
              }
            }));
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.updateFormField = updateFormField;
var fetchLoanDocument = function fetchLoanDocument() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch, getState) {
      var _getState3, document, iframeURL, documentData, file, pdfFile;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _getState3 = getState(), document = _getState3.document;
            iframeURL = document.iframeURL;
            _context4.prev = 2;
            _context4.next = 5;
            return http.get(iframeURL);
          case 5:
            documentData = _context4.sent;
            file = new Blob([documentData.data], {
              type: 'application/pdf'
            });
            pdfFile = '';
            if (window && window.navigator && window.navigator.msSaveOrOpenBlob) {
              // for IE
              window.navigator.msSaveOrOpenBlob(file, 'file_name');
            } else if (window) {
              // for Non-IE (chrome, firefox etc.)
              window.URL = window.URL || window.webkitURL;
              pdfFile = window.URL.createObjectURL(file);
            }
            return _context4.abrupt("return", dispatch({
              type: _constants.FETCH_DOCUMENT,
              payload: {
                data: pdfFile,
                error: false
              }
            }));
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", dispatch({
              type: _constants.FETCH_DOCUMENT,
              payload: {
                error: true
              }
            }));
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 12]]);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
exports.fetchLoanDocument = fetchLoanDocument;
